import "fontsource-roboto";
import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import AxiosConfig from "./AxiosConfig";
import "./index.css";

AxiosConfig.init();

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById("root")
);
